"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDuplicableGroupName = getDuplicableGroupName;
exports.isConditionallyShownFieldVisible = isConditionallyShownFieldVisible;

var _consts = require("../consts");

var _FormTemplateFieldTypes = require("../consts/FormTemplateFieldTypes");

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function isLocationFieldOption(option) {
  return !!option && _typeof(option) === 'object' && 'id' in option && 'name' in option;
}

function getDisplaySingleLocationFieldValue(value, templateField) {
  if (!value) return null;

  try {
    var parsedValue = JSON.parse(value);

    if (!Array.isArray(parsedValue) || !parsedValue.length) {
      return null;
    }

    var mapFeatureId = parsedValue[0];
    var selectedOption = templateField.options.find(function (option) {
      if (isLocationFieldOption(option)) {
        return option.id === mapFeatureId;
      }

      return false;
    });
    return (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.name) || null;
  } catch (_unused) {
    return null;
  }
}

function getDisplayFieldValue(templateField, submissionGroup) {
  if (!_FormTemplateFieldTypes.supportedDuplicableGroupDisplayFieldTypes.includes(templateField.type)) {
    return null;
  }

  var submissionField = submissionGroup.fields.find(function (sf) {
    return sf.fieldSlug === templateField.slug;
  });
  if (!submissionField) return null;
  var fieldValue = submissionField.fieldValue;
  if (!fieldValue) return null;

  if (templateField.type === _FormTemplateFieldTypes.FormTemplateFieldTypes.SINGLE_LOCATION) {
    return getDisplaySingleLocationFieldValue(fieldValue, templateField);
  }

  return typeof fieldValue === 'string' ? fieldValue : null;
}

function getDuplicableGroupName(templateGroup, submissionGroup) {
  var orderNumber = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var defaultGroupName = "".concat(templateGroup.name, " ").concat(orderNumber);
  var templateDisplayFields = templateGroup.fields.filter(function (f) {
    return f.isDuplicableDisplayField;
  }).sort(function (f1, f2) {
    return f1.orderNumber > f2.orderNumber ? 1 : -1;
  });

  if (!templateDisplayFields.length) {
    return defaultGroupName;
  }

  var namePartials = templateDisplayFields.map(function (templateField) {
    return getDisplayFieldValue(templateField, submissionGroup);
  });
  var nonEmptyNamePartials = namePartials.filter(function (p) {
    return !!p;
  });

  if (!nonEmptyNamePartials.length) {
    return defaultGroupName;
  }

  return nonEmptyNamePartials.join(' - ');
}

function contains(value, testValues) {
  if (!value) {
    return false;
  }

  var standardizedValue = (value !== null && value !== void 0 ? value : '').toString().trim();
  var standardizedTestValues = testValues.map(function (v) {
    return v.toString().trim();
  });
  return !!standardizedTestValues.find(function (v) {
    return standardizedValue.includes(v);
  });
}

function isConditionallyShownFieldVisible(fieldValue, operator, conditionalFieldValue) {
  if (!operator) {
    return true;
  }

  var valuesToTestAgainst = (conditionalFieldValue || '').split('|');
  var testValues = (Array.isArray(valuesToTestAgainst) ? valuesToTestAgainst : [valuesToTestAgainst]).map(function (v) {
    return v.toString();
  });

  switch (operator) {
    case _consts.FormConditionalOperator.BLANK:
      return !fieldValue;

    case _consts.FormConditionalOperator.NOT_BLANK:
      return !!fieldValue;

    case _consts.FormConditionalOperator.EQUAL:
      return !!fieldValue && testValues.includes(fieldValue);

    case _consts.FormConditionalOperator.NOT_EQUAL:
      return !fieldValue || !conditionalFieldValue || !testValues.includes(fieldValue);

    case _consts.FormConditionalOperator.CONTAINS:
      return !!fieldValue && contains(fieldValue, testValues);

    case _consts.FormConditionalOperator.DOES_NOT_CONTAIN:
      return !fieldValue || !contains(fieldValue, testValues);

    default:
      throw new Error("You shouldn't get here, there is a conditional operator not accounted for: ".concat(operator));
  }
}